import { useEffect } from "react";
import { X } from "lucide-react";

export const PLAIN_JOB = { lead: "Enquiry", quoted: "Quoted", scheduled: "Scheduled", in_progress: "In progress", waiting_customer: "Waiting on customer", waiting_materials: "Waiting on materials", waiting_sub: "Waiting on sub", on_hold: "On hold", completed: "Complete", invoiced: "Complete", closed: "Complete", cancelled: "Cancelled" };
export const plainJob = (s) => PLAIN_JOB[s] || String(s || "").replace(/_/g, " ");
export const isDone = (j) => ["completed", "invoiced", "closed", "cancelled"].includes(j.status);

// Horizontal segmented control — scrolls on small screens, never wraps into a wall of tabs.
export function Segments({ items, value, onChange, testid = "seg" }) {
  return (
    <div className="seg" role="tablist" data-testid={testid}>
      {items.map((it) => (
        <button key={it.value} type="button" role="tab" aria-selected={value === it.value} onClick={() => onChange(it.value)} className={`seg-item ${value === it.value ? "seg-item-active" : ""}`} data-testid={`${testid}-${it.value}`}>
          {it.label}{it.count > 0 && <span className="seg-count">{it.count}</span>}
        </button>
      ))}
    </div>
  );
}

// Bottom sheet (mobile) / centred dialog (desktop) for short, single-purpose actions.
export function Sheet({ open, onClose, title, subtitle, children, testid }) {
  useEffect(() => { if (!open) return undefined; const k = (e) => e.key === "Escape" && onClose(); document.addEventListener("keydown", k); return () => document.removeEventListener("keydown", k); }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-zinc-950/50 backdrop-blur-sm sm:items-center sm:p-6" onClick={onClose} data-testid={testid}>
      <div className="sheet sm:max-w-lg sm:rounded-xl" onClick={(e) => e.stopPropagation()}>
        <div className="row mb-3"><div><div className="t1 text-[17px] font-semibold">{title}</div>{subtitle && <div className="t3 text-[13px]">{subtitle}</div>}</div><button onClick={onClose} className="btn-icon !h-10 !w-10" aria-label="Close" data-testid={testid ? `${testid}-close` : undefined}><X size={20} /></button></div>
        {children}
      </div>
    </div>
  );
}

export function ActionRow({ icon: I, title, sub, onClick, testid, tone }) {
  return (
    <button type="button" onClick={onClick} className="flex min-h-[60px] w-full items-center gap-3.5 border-b border-line py-2 text-left last:border-b-0" data-testid={testid}>
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${tone === "amber" ? "bg-amber-500/15 text-amber-600" : "bg-surface-2 t2"}`}><I size={19} /></span>
      <span className="min-w-0 flex-1"><span className="t1 block text-[15px] font-semibold">{title}</span>{sub && <span className="t3 block text-[12.5px]">{sub}</span>}</span>
    </button>
  );
}
